import { gql } from "@apollo/client";
import { useGetPossibleShippingDestinationsQuery } from "lib/graphql-generated";
import { inputClassNames, labelClassNames } from "components/forms/input";
import { Dispatch, SetStateAction } from "react";

const SHIPPING_OPTIONS = gql`
  query GetPossibleShippingDestinations {
    regions(
      where: {
        _or: [
          { shipping_options: { deleted_at: { _is_null: true } } }
          {
            countries: { shipping_options: { deleted_at: { _is_null: true } } }
          }
        ]
      }
    ) {
      __typename
      code
      name
      countries(
        where: {
          _or: [
            {
              region_data: {
                shipping_options: { deleted_at: { _is_null: true } }
              }
            }
            { shipping_options: { deleted_at: { _is_null: true } } }
          ]
        }
      ) {
        __typename
        code
        name
      }
    }
  }
`;

interface Props {
  label?: string;
  id?: string;
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
  className?: string;
  disabled?: boolean;
}

export const CountrySelector = ({
  label,
  id,
  value,
  setValue,
  className,
  disabled,
}: Props) => {
  const { data, error, networkStatus } =
    useGetPossibleShippingDestinationsQuery();
  const innerId = id ?? "shippingDestinationSelector";

  return (
    <label htmlFor={innerId} className={`${className} text-sm`}>
      <span className={`${labelClassNames}`}>{label}</span>
      <select
        disabled={disabled}
        id={innerId}
        name={innerId}
        className={inputClassNames}
        value={value || ""}
        onChange={(e) => setValue(e.target.value)}>
        <option value='' disabled className='text-gray-500'>
          Select a country
        </option>
        {data?.regions?.map((r, i) => (
          <optgroup label={r.name} key={`region_${r.code}`}>
            {r.countries.map((c) => (
              <option key={`country_${c.code}`} value={c.code}>
                {c.name}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </label>
  );
};
